// Role Hierarchy - Her rolün seviyesi
export const roleHierarchy = {
  'park_gorevlisi': 1,
  'gorevli': 1,
  'formen': 2,
  'bolge_muhendisi': 3,
  'mudur_yardimcisi': 4,
  'mudur': 5
};

/**
 * Sistem admin rolünü tespit eder. Admin (slug='admin') kullanıcı yönetim
 * hiyerarşisinin DIŞINDA, ayrı bir teknik rol kategorisidir; "yönetici" veya
 * "personel" sayılmaz. Bu helper hiyerarşi/amir/personel listelerinde admin'i
 * filtrelemek için kullanılır.
 *
 * @param {string|object} roleOrSlug - "admin" string slug veya { slug, ... } obje
 */
export const isSystemAdminRole = (roleOrSlug) => {
  if (!roleOrSlug) return false;
  const slug = typeof roleOrSlug === 'string'
    ? roleOrSlug
    : (roleOrSlug.slug || roleOrSlug.role || '');
  return String(slug).toLowerCase() === 'admin';
};

/**
 * Personeli sistem admini mi diye kontrol eder. p.role veya p.role_id'den
 * türetilen rol slug'ına bakar. roleHelpers opsiyoneldir (sadece role_id
 * bazlı tespit için gerekli).
 */
export const isSystemAdminPersonnel = (personnel, roleHelpers = {}) => {
  if (!personnel) return false;
  if (isSystemAdminRole(personnel.role)) return true;
  if (personnel.role_id && roleHelpers.getRoleById) {
    const r = roleHelpers.getRoleById(personnel.role_id);
    if (r && isSystemAdminRole(r.slug)) return true;
  }
  return false;
};

// Açıklama Görünürlüğü Kontrolü
export const canSeeApprovalComment = (viewerRole, commenterRole, requestStatus, viewerId, commenterId) => {
  const viewerLevel = roleHierarchy[viewerRole] || 0;
  const commenterLevel = roleHierarchy[commenterRole] || 0;
  
  // KENDİ açıklamasını HERKES görebilir
  if (viewerId === commenterId) return true;
  
  // Müdür'ün açıklamasını HERKES görebilir
  if (commenterRole === 'mudur') return true;
  
  // Park Görevlisi özel durum
  if (viewerLevel === 1) {
    if (requestStatus === 'approved' || requestStatus === 'rejected' || requestStatus === 'cancelled') {
      return commenterRole === 'mudur';
    }
    return false;
  }
  
  return viewerLevel > commenterLevel;
};

// Approval History Filtreleme
export const filterApprovalHistory = (approvalHistory, viewerRole, requestStatus, viewerId) => {
  if (!approvalHistory || approvalHistory.length === 0) return [];
  
  return approvalHistory.filter(step => {
    return canSeeApprovalComment(viewerRole, step.approver_role, requestStatus, viewerId, step.approver_id);
  });
};

// Helper fonksiyon: Bir yöneticinin TÜM alt personelini recursive olarak bul
export const getAllSubordinates = (managerId, managerRole, personnel) => {
  const directSubordinates = [];
  
  if (managerRole === 'formen') {
    directSubordinates.push(
      ...personnel.filter(p => 
        p.formen_id === managerId || 
        (p.parent_id === managerId && p.role === 'park_gorevlisi')
      )
    );
  } else if (managerRole === 'bolge_muhendisi') {
    const formens = personnel.filter(p => 
      p.bolge_muhendisi_id === managerId ||
      (p.parent_id === managerId && p.role === 'formen')
    );
    directSubordinates.push(...formens);
    
    formens.forEach(formen => {
      const formenSubordinates = personnel.filter(p => 
        p.formen_id === formen.id || 
        (p.parent_id === formen.id && p.role === 'park_gorevlisi')
      );
      directSubordinates.push(...formenSubordinates);
    });
    
    directSubordinates.push(
      ...personnel.filter(p => 
        p.bolge_muhendisi_id === managerId && p.role === 'park_gorevlisi'
      )
    );
  } else if (managerRole === 'mudur_yardimcisi') {
    const mühendisler = personnel.filter(p => 
      p.mudur_yardimcisi_id === managerId ||
      (p.parent_id === managerId && p.role === 'bolge_muhendisi')
    );
    directSubordinates.push(...mühendisler);
    
    mühendisler.forEach(mühendis => {
      const mühendisSubordinates = getAllSubordinates(mühendis.id, 'bolge_muhendisi', personnel);
      directSubordinates.push(...mühendisSubordinates);
    });
  }
  
  // Duplicate'leri kaldır
  const uniqueSubordinates = directSubordinates.filter((person, index, self) =>
    index === self.findIndex(p => p.id === person.id)
  );
  
  return uniqueSubordinates;
};
